export default __webpack_public_path__ + "static/media/logo_admin.4be54791.png";